/**
 * The actions provided by the AppClientSDK.
 */
export enum AppsEngineUIMethods {
    GET_USER_INFO = 'getUserInfo',
    GET_ROOM_INFO = 'getRoomInfo',
}
